import { render, staticRenderFns } from "./MtiporesolucionFormHeader.vue?vue&type=template&id=efadef6a"
import script from "./MtiporesolucionFormHeader.vue?vue&type=script&lang=js"
export * from "./MtiporesolucionFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports